import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TourBudgetViewDto } from '@/features/dashboard/tourBudget/types/TourBudgetDto.ts';
import { SetTourBudgetRequestDto } from '@/features/dashboard/tourBudget/types/TourBudgetRequest.ts';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

/** Każda z metod zwraca pełny, przeliczony widok — po jednym wpisie na walutę. */
const tourBudgetApi = {
  getBudget: async (tourId: string): Promise<TourBudgetViewDto[]> => {
    return await fetchPrivateApi<TourBudgetViewDto[]>(
      'GET',
      `tours/${tourId}/budget`,
    );
  },

  setBudget: async (
    tourId: string,
    dto: SetTourBudgetRequestDto,
  ): Promise<TourBudgetViewDto[]> => {
    return await fetchPrivateApi<TourBudgetViewDto[]>(
      'PUT',
      `tours/${tourId}/budget`,
      dto,
    );
  },

  removeBudget: async (
    tourId: string,
    currency: Currency,
  ): Promise<TourBudgetViewDto[]> => {
    return await fetchPrivateApi<TourBudgetViewDto[]>(
      'DELETE',
      `tours/${tourId}/budget/${currency}`,
    );
  },
};

export default tourBudgetApi;
